import CryptoJS from 'crypto-js'
import moment from 'moment'
import { pushPlatformEvent, lowestPrice, residencyPrice, residencyCurrency, roomItem } from '../../utils/ecommerce'
export default {
  data () {
    return {
      baseUrl: '',
      type: 'live',
      initialPropertyId: '',
      initialPropertyName: '',
      ratePlanRoomId: '',
      ratePlanBoardCode: '',
      ratePlanResidency: '',
      trackedViewItemIds: []
    }
  },
  watch: {
    bookingData (val) {
      if (!this.initialPropertyName && val && val.name) {
        this.initialPropertyName = val.name
        // console.log('[mixin:watch:bookingData] initialPropertyName captured:', this.initialPropertyName)
      }
      // Fire view_item as soon as a room and its rates are shown on the results page,
      // rather than waiting for a "view details" click that most guests never make.
      if (val && val.rooms) {
        const rooms = Array.isArray(val.rooms) ? val.rooms : Object.values(val.rooms)
        rooms.forEach(room => {
          if (room && room.id !== undefined && !this.trackedViewItemIds.includes(room.id)) {
            this.trackedViewItemIds.push(room.id)
            this.trackViewItem(room)
          }
        })
      }
    }
  },
  created: async function () {
    if (this.$root.account_type !== undefined) {
      if (this.$root.account_type !== '') {
        this.baseUrl = process.env.PROD_TYPE[this.$root.account_type].url
        this.type = this.$root.account_type
      } else {
        this.baseUrl = this.baseUrl = process.env.PROD_TYPE['demo'].url
        this.type = 'demo'
      }
    } else {
      this.baseUrl = this.baseUrl = process.env.PROD_TYPE['live'].url
      this.type = 'live'
    }
  },
  methods: {
    openTermsAndCondition () {
      const el = this.$el.getElementsByClassName('terms_section')[0]
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        })
      }
      this.accordion = true
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('vue-card-unit')[0]
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    formatPrice (value) {
      if (isNaN(value)) {
        return value
      } else {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    getUrlParameter (name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      var results = regex.exec(location.search)
      return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '))
    },
    getUrlData () {
      let hash = document.location.hash
      let urlparameters = hash.split('?')[1]
      if (this.$root.multiproperty !== undefined && this.$root.multiproperty !== '') {
        this.multipropertyStatus = this.$root.multiproperty
      } else if (this.$root.id === '') {
        // set multiproperty for demo
        this.multipropertyStatus = true
      }
      let roomId = this.getUrlParameter('roomid') !== '' ? this.getUrlParameter('roomid') : this.getUrlParameter('room_id')
      if (urlparameters !== undefined) {
        let propid = urlparameters.split('&')[0]
        let encodedpid = propid.split('=')[1]
        let reconstructedpid1 = encodedpid.split('%3D')
        let reconstructedpid = reconstructedpid1.join('=')
        this.propertyid = atob(reconstructedpid)
      } else {
        let pid = this.getUrlParameter('pid')
        let hotelID = this.getUrlParameter('hotelID')
        if (pid !== '' || hotelID !== '') {
          this.propertyid = this.destination = pid !== '' ? pid : hotelID
        } else {
          this.propertyid = this.$root.id !== '' ? this.$root.id : 81
          // redirect to multiproperty page
          if (this.multipropertyStatus === true && this.$route.path !== '/multi-property') {
            if (this.$root.layout === undefined) {
              this.$router.push({
                path: '/multi-property'
              })
            } else {
              if (this.$root.layout === 'multiple' || this.$root.layout === '') {
                this.$router.push({
                  path: '/multi-property'
                })
              }
            }
          }
        }
      }
      if (roomId !== '') {
        this.gotoRoomDetail(roomId)
      }
      //
      let rooms = this.getUrlParameter('rooms') !== '' ? this.getUrlParameter('rooms') : this.getUrlParameter('no_rooms')
      let children = this.getUrlParameter('children') !== '' ? this.getUrlParameter('children') : 0
      let babies = this.getUrlParameter('babies') !== '' ? this.getUrlParameter('babies') : 0
      let residency = this.getUrlParameter('residency')
      let adults = this.getUrlParameter('adults') !== '' ? this.getUrlParameter('adults') : 1
      let couponCode = this.getUrlParameter('coupon_code')
      let email = this.getUrlParameter('client_email')
      // if data is via url
      if (this.getUrlParameter('children') !== '' || this.getUrlParameter('adults') !== '' || this.getUrlParameter('rooms') !== '' || couponCode !== '') {
        this.defaultAdultNo = adults
        this.defaultChildrenNo = children
        this.email = email !== '' ? email : this.email
        this.defaultbabiesNo = babies
        this.room = (rooms !== '' && parseInt(rooms) !== 0) ? parseInt(rooms) : 1
        this.babies = babies !== '' ? babies : 0
        if (parseInt(rooms) === 1 && parseInt(adults) === 0 && parseInt(children) === 0) {
          this.room = 1
          this.adult = 1
          this.children = 0
        } else {
          this.adult = parseInt(adults)
          this.children = parseInt(children)
        }
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        this.resident = residency !== '' ? residency : this.resident
        let childageArray = urlParams.getAll('children_ages[]')
        var childrenAges = childageArray.length > 0 ? urlParams.getAll('children_ages[]') : urlParams.getAll('childages')
        this.childAges = childrenAges !== '' ? childrenAges : this.childAges
        this.promo = couponCode !== '' ? couponCode : this.promo
        this.guest = parseInt(this.adult) + parseInt(this.babies) + parseInt(this.children)
        this.proofRes = this.resident === 'resident' ? 0 : 1

        // const payload2 = {
        //   checkin_date: this.chckInDate,
        //   checkout_date: this.chckOutDate
        // }
        // this.$store.commit('updateDates', payload2)

        const payload = {
          roomNo: this.room,
          promoCode: this.promo,
          proofRes: this.proofRes,
          residency: this.resident
        }
        this.$store.commit('updateRoomNo', payload)
      }
      // Parse ratePlanID: format {roomID}_{boardCode}_{countryCode}_{RES|NONRES}
      // e.g. 3821_BO_KE_RES or 3821_BO_KE_NONRES
      const ratePlanID = this.getUrlParameter('ratePlanID')
      // console.log('[ratePlanID] raw param:', ratePlanID)
      if (ratePlanID !== '') {
        const parts = ratePlanID.split('_')
        // console.log('[ratePlanID] parts:', parts, '| length:', parts.length)
        if (parts.length >= 4) {
          this.ratePlanRoomId = parts[0]
          this.ratePlanBoardCode = parts[1]
          const resType = parts[parts.length - 1]
          // console.log('[ratePlanID] roomId:', this.ratePlanRoomId, '| boardCode:', this.ratePlanBoardCode, '| resType:', resType)
          if (resType === 'RES') {
            this.ratePlanResidency = 'res'
            this.resident = 'resident'
            this.proofRes = 0
          } else if (resType === 'NONRES') {
            this.ratePlanResidency = 'nonres'
            this.resident = 'non-resident'
            this.proofRes = 1
          }
          // console.log('[ratePlanID] after parse → ratePlanResidency:', this.ratePlanResidency, '| proofRes:', this.proofRes, '| resident:', this.resident)
          const ratePlanPayload = {
            roomNo: this.room,
            promoCode: this.promo,
            proofRes: this.proofRes,
            residency: this.resident
          }
          this.$store.commit('updateRoomNo', ratePlanPayload)
        } else {
          console.warn('[ratePlanID] not enough parts — expected 4, got:', parts.length)
        }
      }
    },
    gotoRoomDetail (roomid, availability = null, allowonlinebooking = true, booking = null) {
      // view_item already fires from the results-page watcher as soon as the room's
      // rates are shown, so this click just navigates — no separate push here.
      if (roomid !== '' && availability !== 0 && allowonlinebooking) {
        this.$router.push({
          path: '/room-details?rid=' + roomid + '&pid=' + btoa(this.propertyid)
        })
      }
    },
    trackViewItem (booking) {
      const value = lowestPrice(booking.boards, this.proofRes)
      pushPlatformEvent('view_item', {
        hotel_id: this.propertyid,
        hotel_name: this.bookingData ? this.bookingData.name : '',
        currency: residencyCurrency(this.bookingData ? this.bookingData.currency : '', this.proofRes),
        value: value,
        items: [roomItem(booking, null, value, 1)]
      })
    },
    trackAddToCart (booking, board) {
      const value = residencyPrice(board.roomPriceAfterDiscount, this.proofRes)
      pushPlatformEvent('add_to_cart', {
        hotel_id: this.propertyid,
        hotel_name: this.bookingData ? this.bookingData.name : '',
        currency: residencyCurrency(this.bookingData ? this.bookingData.currency : '', this.proofRes),
        value: value,
        items: [roomItem(booking, board, value, 1)]
      })
    },
    async getOffers (propertyid) {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let fetchUrl = details.url
        const posturl = `${fetchUrl}/index.php` //
        const postData = {
          property_ids: propertyid
        }
        var postDataJson = JSON.stringify(postData)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
        try {
          const formData = new FormData()
          formData.append('consumer_key', consumerKey)
          formData.append('data', encryptedData)
          formData.append('option', 'com_goreserva_psearch')
          formData.append('task', 'api.getPropertyOffers')
          // const response = await this.axios.get(this.url, config)
          const response = await this.axios.post(posturl, formData)
          if (response) {
            let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
            this.errors = false
            this.errorMsg = []
            if (data !== '') {
              data = JSON.parse(data)
              this.offers = data
            }
          }
        } catch (error) {}
      }
    },
    async getPropertySettings (propertyId) {
      try {
        const configUrl = process.env.CONFIG_URL['live_url']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': propertyId,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {}
        // return pdetails
      } catch (error) {
      //
        this.propertyConfigs = []
      }
      return this.propertyConfigs
    },
    async fetchData () {
      this.propertyerror = false
      // manage booking
      var manageBooking = this.$route.query.manage
      var manageBookingData = manageBooking ? this.$store.getters.bookingDetails : ''
      // end: manage booking
      const postData = {
        checkin_date: manageBooking ? this.dateIn : this.checkinDate,
        checkout_date: manageBooking ? this.dateOut : this.checkoutDate,
        room: manageBooking ? manageBookingData.details[0].no_room : this.room,
        babies: manageBooking ? manageBookingData.details[0].babies : this.babies,
        children: manageBooking ? manageBookingData.details[0].children : this.children,
        children_ages: manageBooking ? manageBookingData.details[0].children_ages : this.childAges,
        adults: manageBooking ? manageBookingData.details[0].adults : this.adult,
        coupon_code: this.promo,
        client_email: this.email
      }
      const postDataJson = JSON.stringify(postData)
      // calling api to get keys
      try {
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          const encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          const posturl = `${fetchUrl}/index.php`
          try {
            const formData = new FormData()
            formData.append('pid', this.propertyid)
            formData.append('consumer_key', consumerKey)
            formData.append('data', encryptedData)
            formData.append('option', 'com_goreserva_psearch')
            formData.append('task', 'api.searchAvailability')
            // const response = await this.axios.get(this.url, config)
            const response = await this.axios.post(posturl, formData)
            if (response) {
              let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
              this.errors = false
              this.errorMsg = []
              if (data !== '') {
                data = JSON.parse(data)
                const maxNight = data.data[this.propertyid].maximum_nights
                let maximumOccupancy = 0
                let maximumAdultOccupancy = 0
                if (parseInt(this.period) > parseInt(maxNight)) {
                  this.clicked = true
                  this.dataToggle = 'tooltip'
                  this.errMsg = 'Maximum (' + maxNight + ') nights exceeded'
                  this.$toast.error(this.errMsg)
                }
                for (const room of Object.values(data.data[this.propertyid].rooms)) {
                  if (room.occupancy.maximumTotalOccupancy > maximumOccupancy) {
                    maximumOccupancy = room.occupancy.maximumTotalOccupancy
                  }
                  if (room.occupancy.maximumAdultOccupancy > maximumAdultOccupancy) {
                    maximumAdultOccupancy = room.occupancy.maximumAdultOccupancy
                  }
                }
                if (parseInt(this.period) < parseInt(maxNight) && (this.room >= 2 || parseInt(this.guest) > parseInt(maximumOccupancy) || parseInt(this.adult) > parseInt(maximumAdultOccupancy))) {
                  if (this.$route.path === '/multi-property' || this.$route.path === '/') {
                    this.$router.push({
                      path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
                    })
                  }
                }

                this.bookings = data
                this.roomData = this.bookings.data[this.propertyid].rooms
                this.bookingData = this.bookings.data[this.propertyid]
                this.roomLabel = this.bookings.data[this.propertyid].room_label
                this.guestFormSettings = this.bookings.data[this.propertyid].guest_form_settings
                this.ageGroupsDetails = this.bookings.data[this.propertyid].age_group_details
                if (this.bookings.data[this.propertyid].rooms.length === 0) {
                  this.errors = true
                  this.errorMsg.push('No available rates')
                }
                var timex = setInterval(() => {
                  if (!this.checkinDate) {
                    this.getDateData()
                  }
                }, 100)
                setTimeout(() => clearInterval(timex), 20000)
                for (const object of Object.values(
                  this.bookings.data[this.propertyid].rooms
                )) {
                  for (const board of Object.values(object.boards)) {
                    if (board.roomPrice.res === 0 || board.roomPrice.res === '') {
                      this.residenceTab = true
                    } else if (
                      board.roomPrice.nonres === 0 ||
                    board.roomPrice.nonres === ''
                    ) {
                      this.residenceTab = true
                    }
                  }
                }
                // console.log('[fetchData] currency.res:', this.bookings.data[this.propertyid].currency.res, '| currency.nonres:', this.bookings.data[this.propertyid].currency.nonres, '| residenceTab:', this.residenceTab)
                // console.log('[fetchData] ratePlanResidency:', this.ratePlanResidency, '| proofRes before currency block:', this.proofRes)
                if (
                  this.bookings.data[this.propertyid].currency.res !== '' &&
                this.bookings.data[this.propertyid].currency.nonres === ''
                ) {
                  // console.log('[fetchData] branch: ONLY RESIDENT rates available → proofRes=0')
                  this.proofRes = 0
                  this.residenceTab = true
                } else if (
                  this.bookings.data[this.propertyid].currency.res === '' &&
                this.bookings.data[this.propertyid].currency.nonres !== ''
                ) {
                  // console.log('[fetchData] branch: ONLY NON-RESIDENT rates available → proofRes=1')
                  this.proofRes = 1
                  this.residenceTab = true
                } else {
                  const defaultRes = this.ratePlanResidency ||
                    this.bookings.data[this.propertyid].guest_form_settings.default_residency
                  // console.log('[fetchData] branch: BOTH currencies available | defaultRes:', defaultRes, '(ratePlanResidency:', this.ratePlanResidency, ', property default:', this.bookings.data[this.propertyid].guest_form_settings.default_residency, ')')
                  if (defaultRes === 'res') {
                    this.resident = 'resident'
                    this.proofRes = 0
                    this.proof = true
                  } else if (defaultRes === 'nonres') {
                    this.resident = 'non-resident'
                    this.proofRes = 1
                    this.proof = false
                  }
                }
                // console.log('[fetchData] proofRes after currency block:', this.proofRes)
                // ratePlanID residency always wins — force it after all currency checks
                if (this.ratePlanResidency === 'nonres') {
                  // console.log('[fetchData] ratePlanID override → forcing proofRes=1 (non-resident)')
                  this.proofRes = 1
                  this.resident = 'non-resident'
                  this.resNonRes = 'nonres'
                } else if (this.ratePlanResidency === 'res') {
                  // console.log('[fetchData] ratePlanID override → forcing proofRes=0 (resident)')
                  this.proofRes = 0
                  this.resident = 'resident'
                  this.resNonRes = 'res'
                }
                // console.log('[fetchData] FINAL proofRes:', this.proofRes, '| resident:', this.resident)
                // getting multiproperties
                const payload = {
                  bookingData: this.bookings,
                  stay_period: this.period,
                  babies: this.babies,
                  childAges: this.childAges
                }
                // check if period exceeds the maximum nights allowed

                this.$store.dispatch('getBookingData', payload)
                this.$store.commit('updateLoyaltyIsEnabled', this.guestFormSettings.is_loyalty_enabled)
                this.$store.commit('updateGtmContainerId', this.guestFormSettings.gtm_container_id)
                this.spinner = true
                if (this.bookingData.show_coupon_ads === 1) {
                  this.getOffers(this.propertyid)
                }
              } else {
                this.errors = true
                this.errorMsg.push('Failed to decrypte data')
              }
            }
          } catch (error) {
            console.log('error', error)
          }
        //
        } else {
          this.propertyerror = false
        }
      } catch (error) {
        console.log(error)
        this.propertyerror = false
      }

      // end
    },
    redirectToBookDetail (booking, board) {
      if (parseInt(booking.occupancy.maximumAdultOccupancy) < parseInt(this.adult)) {
        this.$toast.error('You have exceeded the maximum number of adults on a room')
        this.$router.push({
          path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
        })
      } else if (this.adult === 0 && parseInt(booking.occupancy.maximumChildOnlyOccupancy) < parseInt(this.children)) {
        this.$toast.error('You cannot have more ' + booking.occupancy.maximumChildOnlyOccupancy + ' children only in a room')
        this.$router.push({
          path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
        })
      } else if (this.adult === 1 && parseInt(booking.occupancy.maximumChildSharingOccupancy < parseInt(this.children))) {
        this.$toast.error('You cannot have more than ' + booking.occupancy.maximumChildSharingOccupancy + ' Children sharing a room')
        this.$router.push({
          path: '/multi-room-selection/?pid=' + btoa(this.propertyid)
        })
      } else if (parseInt(this.children) !== this.childAges.length) {
        let childtype = this.children > 1 ? 'children' : 'child'
        this.$toast.error('please Add ' + childtype + ' Ages')
      } else {
        this.spinner = false
        this.trackAddToCart(booking, board)
        const payload = {
          room: booking,
          board: board,
          res: this.proofRes,
          resident: this.resident,
          adults: this.adult,
          children: this.children,
          babies: this.babies,
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate
        }
        this.$store.dispatch('gotoBookDetail', payload)
        if (this.$route.query.manage) {
          this.$router.push({
            path: '/booking-detail/?pid=' + btoa(this.propertyid),
            query: {
              manage: 1
            }
          })
        } else {
          this.$router.push({
            path: '/booking-detail/?pid=' + btoa(this.propertyid)
          })
        }
      }
    },
    CryptoJSAesEncrypt (passphrase, plainData) {
      var salt = CryptoJS.lib.WordArray.random(256)
      var iv = CryptoJS.lib.WordArray.random(16)
      var key = CryptoJS.PBKDF2(passphrase, salt, {
        hasher: CryptoJS.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999
      })

      var encrypted = CryptoJS.AES.encrypt(plainData, key, {
        iv: iv
      })

      var data = {
        ciphertext: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
        salt: CryptoJS.enc.Hex.stringify(salt),
        iv: CryptoJS.enc.Hex.stringify(iv)
      }
      // var encryptedDatajson = data
      return btoa(JSON.stringify(data))
    },
    CryptoJSAesDecrypt (passphrase, encryptedjsonstring) {
      let response = ''
      try {
        var objJson1 = atob(encryptedjsonstring)
        var objJson = JSON.parse(objJson1)

        var encrypted = objJson.ciphertext
        var salt = CryptoJS.enc.Hex.parse(objJson.salt)
        var iv = CryptoJS.enc.Hex.parse(objJson.iv)

        var key = CryptoJS.PBKDF2(passphrase, salt, {
          hasher: CryptoJS.algo.SHA512,
          keySize: 64 / 8,
          iterations: 999
        })

        var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv: iv
        })
        response = decrypted.toString(CryptoJS.enc.Utf8)
      } catch (error) {
        response = ''
      }
      return response
    },
    async fetchCountries () {
      try {
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          const formData = new FormData()
          formData.append('pid', this.propertyid)
          formData.append('consumer_key', consumerKey)
          formData.append('data', 'eyJjaXBoZXJ0ZXh0IjoibFp5dUlFRFl4Y05iWVl5V0ltK1ZLVnZ1QXVpSElVOUZqYzVSY3Yydzh3WHZKREhcL2lqUnFLdlJPZEJpNFZVVStIUXFUR3hNb1lKRWJFa1FBQk5uSHpvZ2VGb0VLekd5aWtDS2l4Nml3bFl2WFpoWUNkR2pZNUg3ZWhHZzVOeVQxOVRUWWNHbFVKbFwvYUxVOEMzTSsrNVE9PSIsIml2IjoiZmJmMGI4ZmYwYjk3Mjc0M2MwMDQzOTIwMmQ3M2Y3YzciLCJzYWx0IjoiN2RlYjNmYzE5MDA2OTkxNDIzZmY5YzA4ZTE3ZDUwZmE1YjY0ODQ5NmY2YTI0N2Y2Y2E5NTQ3ODI5ZDMyNzQ1NzA0MzM2YWQyYzRlMDRkODAwMzIzODUyZjIwNmJhYWFjODZlOTVmNzRkYzUxZmI2MjEwYmI2MTRjOTU2YmZkMWMzMTU5OWFiYmNkOTE2OTZmNTlhMTZmYTUxNzFmNzg2YWI4M2E0NzUzNTA2ZTNjOWExM2RlZGU1ZDAxYjcxNzA1N2I5ODQ4YjdlOTk3MTU4MDBlZjc2NjYzYTE1YWM0ZTA0N2FhYzE5N2U4ODg3ZTI4ZTVhNDYwMjA5Y2VkNDZmNDM4ZTdjZjdjZGE5NWNhN2Q5NDUzMTEwNmNiNmI0YWJiYTkxN2UyM2JmOWJmMDlmY2M0NWY1Zjg5MDJmNjQ3OWEwMjU4NjRjYmM1NWI0ZDEwZjQxNGVjNzUyNTNjYTE5YzQ0ODlhYmQyM2EyMzEyOWI3YzNjNjEwZTgyZTIxOWY2YzZmMDM1NGQ2YzNiNjE0Y2Y3NGYzYWViYzk3YmNkMWI2OWFjNmIzNzA2ZDNlODMzNTFiNDYwNjg2NmFjZDk5OTQ5YzFmYzBiNDVhOGJkYWYyYWY0ZGUwMzIyZjNjYmUyNzVkZjY2NzcwNDA0ZTc4YTcxMGQ2NzMxZGExMDE3NmMifQ')
          formData.append('option', 'com_goreserva_psearch')
          formData.append('parsetojson', 1)
          formData.append('encoded', 1)
          formData.append('task', 'api.getCountriesDropDownList')

          var url = `${fetchUrl}/index.php`
          const response = await this.axios.post(url, formData)
          if (response) {
            let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
            if (data !== '') {
              data = JSON.parse(data)
              this.countries = data
            }
          }
        }
      } catch (error) {}
    },
    async fetchEnhancementData () {
      try {
        this.pageloader = false
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          var postData = {
            checkin_date: this.checkinDate,
            checkout_date: this.checkoutDate,
            adults: this.adults,
            children: this.children,
            boards: this.selectedBoard
          }
          var postDataJson = JSON.stringify(postData)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          const formData = new FormData()
          formData.append('pid', this.propertyid)
          formData.append('consumer_key', consumerKey)
          formData.append('data', encryptedData)
          formData.append('option', 'com_goreserva_psearch')
          formData.append('task', 'api.getPropertyEnhancements')

          const url = `${fetchUrl}/index.php`
          const response = await this.axios.post(url, formData)
          if (response) {
            let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
            if (data !== '') {
              data = JSON.parse(data)
              this.addedhenancement = data
              if (this.addedhenancement.length === 0) {
                this.step = 2
                this.trackCartAndCheckout()
              }
              this.pageloader = true
            }
          } else {
            console.log('error, ', response)
          }
        }
      } catch (error) {}
    },
    async gettingMultiProperties () {
      // console.log('[gettingMultiProperties] called | destination:', this.destination, '| propertyid:', this.propertyid)
      if (!this.initialPropertyId && this.propertyid) {
        this.initialPropertyId = String(this.propertyid)
        // console.log('[gettingMultiProperties] initialPropertyId frozen:', this.initialPropertyId)
      }
      try {
        //
        let hash = document.location.hash
        let urlparameters = hash.split('?')[1]
        if (this.destination !== '') {
          this.propertyid = this.destination
        } else {
          if (urlparameters !== undefined) {
            let propid = urlparameters.split('&')[0]
            let encodedpid = propid.split('=')[1]
            let reconstructedpid1 = encodedpid.split('%3D')
            let reconstructedpid = reconstructedpid1.join('=')
            this.propertyid = atob(reconstructedpid)
          } else {
            let pid = this.getUrlParameter('pid')
            if (pid !== '') {
              this.propertyid = pid
            } else {
              this.propertyid = this.$root.id !== '' ? this.$root.id : 81
            }
          }
        }
        const configUrl = process.env.CONFIG_URL['live_url']
        const key = process.env.PMS_KEY['key']
        const config = {
          headers: { 'Accept': 'application/json' }
        }
        const payload = {
          'property_id': this.propertyid,
          'api': this.type
        }
        const configRes = await this.$http.post(configUrl, payload, config)
        if (configRes.status === 200) {
          let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
          configData = JSON.parse(configData)
          const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
          let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
          const details = JSON.parse(configData[0].add_details)
          let fetchUrl = details.url
          const mpropertyDetails = JSON.parse(configData[0].mproperty_details)
          var relatedpids = '' // process.env.RELATED_PROPERTIES[this.propertyid].ids // JSON.stringify(process.env.RELATED_PROPERTIES[this.propertyid].ids)
          if (mpropertyDetails.ids !== '') {
            relatedpids = mpropertyDetails.ids
          } else {
            relatedpids = this.propertyid
          }
          // console.log("Related PIDs", relatedpids);

          const postData = {
            property_ids: relatedpids
          }
          var postDataJson = JSON.stringify(postData)
          var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
          const url = `${fetchUrl}/index.php`
          const formData = new FormData()
          formData.append('consumer_key', consumerKey)
          formData.append('data', encryptedData)
          formData.append('option', 'com_goreserva_psearch')
          formData.append('task', 'api.getMultiPropertyData')
          const response = await this.axios.post(url, formData)
          if (response) {
            let data = this.CryptoJSAesDecrypt(passkey, response.data.er)
            if (data !== '') {
              data = JSON.parse(data)
              this.multiproperties = data
              // console.log('[gettingMultiProperties] multiproperties set:', this.multiproperties.map(p => ({ id: p.id, name: p.propertyName })))
              var arrayFiltered = this.multiproperties.find(
                (x) => x.id === this.propertyid.toString()
              )
              this.filteredRoomTypeArray = arrayFiltered
              if (!this.destination) {
                this.destination = this.propertyid.toString()
                // console.log('[gettingMultiProperties] destination auto-set to:', this.destination)
              } else {
                // console.log('[gettingMultiProperties] destination already set:', this.destination)
              }
            }
          }
        }
      } catch (error) {}
    },
    getDateDataFromUrl() {
      const today = moment().format('YYYY-MM-DD')
      const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD')

      // Extract Url Parameters
      let checkinDate = this.getUrlParameter('checkin_date')
      let checkoutDate = this.getUrlParameter('checkout_date')
      const adultCount = parseInt(this.getUrlParameter('adults')) || 1
      const childrenCount = parseInt(this.getUrlParameter('children')) || 0

      // console.log(checkinDate)
      // console.log(checkoutDate)

      // handle day, month, year format
      const checkinDay = this.getUrlParameter('checkinDay')
      const checkinMonth = this.getUrlParameter('checkinMonth')
      const checkinYear = this.getUrlParameter('checkinYear')
      const nights = parseInt(this.getUrlParameter('nights')) || 1

      if (checkinDay && checkinMonth && checkinYear) {
        checkinDate = moment(`${checkinDay}-${checkinMonth}-${checkinYear}`, 'DD-MM-YYYY')
        checkoutDate = moment(checkinDate).add(nights, 'days').format('YYYY-MM-DD')
      } else if (checkinDate) {
        // handle checkin date format
        const dateArray = checkinDate.split('-')
        checkinDate = dateArray[0].length === 4
          ? moment(checkinDate, 'YYYY-MM-DD')
          : moment(checkinDate, 'DD-MM-YYYY')

        checkoutDate = checkoutDate || moment(checkinDate).add(nights, 'days').format('YYYY-MM-DD')
      } else {
        checkinDate = moment(today)
        checkoutDate = tomorrow
      }

      // ensure checkout is after checkin
      if (moment(checkoutDate).isBefore(checkinDate)) {
        checkoutDate = moment(checkinDate).add(1, 'days').format('YYYY-MM-DD');
      }

      // ensure dates are not in the past
      if (checkinDate.isBefore(today)) {
        checkinDate = moment(today)
        checkoutDate = tomorrow
      }

      this.$store.commit('updateDates', {
        checkin_date: checkinDate.format('YYYY-MM-DD'),
        checkout_date: checkoutDate,
      });

      // update component level states
      this.checkinDate = checkinDate.format('YYYY-MM-DD');
      this.checkoutDate = checkoutDate;
      this.adult = adultCount;
      this.children = childrenCount;

      // calculate stay period
      this.period = this.calculateStayNights(this.checkinDate, this.checkoutDate) || nights;
      this.periodText = this.getPeriodText(this.period);
    },
    calculateStayNights (checkin_date, checkout_date) {
      const checkin = new Date(checkin_date)
      const checkout = new Date(checkout_date)
      var differenceInTime = checkout.getTime() - checkin.getTime()
      var differenceInDays = Math.round(
        differenceInTime / (1000 * 3600 * 24)
      )
      return differenceInDays;
    },
    getPeriodText (period) {
      return period > 1 ? 'nights' : 'night';
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/mixins/reusableData.js